import { render, staticRenderFns } from "./PkFirstFinancialAffairsConfig.vue?vue&type=template&id=ca975a84&"
import script from "./PkFirstFinancialAffairsConfig.vue?vue&type=script&lang=js&"
export * from "./PkFirstFinancialAffairsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports